export default __webpack_public_path__ + "3274f5b870f0af03d52f61e5b04e14b3.png";